import { render, staticRenderFns } from "./ProductsChart.vue?vue&type=template&id=6b5d1dfe&scoped=true&"
import script from "./ProductsChart.vue?vue&type=script&lang=js&"
export * from "./ProductsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d1dfe",
  null
  
)

export default component.exports